import './index.css';

import classnames from 'classnames';
import React, { ChangeEvent } from 'react';

import useDimensions from '../../common/hooks/useDimensions';

export interface FormInputProps {
  name: string;
  label: string;
  type: string;
  multiple?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  className?: string;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  inputClassName?: string;
  maxLength?: number;
  charges: string;
  required: boolean;
  labelClassName: string;
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  error,
  label,
  type,
  multiple,
  onChange,
  value,
  className = '',
  inputClassName = '',
  labelClassName = 'mb-8 inline-block text-16 md:text-14',
  hint,
  maxLength,
  charges,
  required,
}) => {
  const [ref] = useDimensions();

  return (
    <div className={className}>
      <div
        ref={ref}
        className={classnames('form-input-wrapper relative', {
          'form-input-wrapper--error border-input-error': error,
        })}
      >
        <label className={labelClassName} htmlFor={name} font-customisation="para-text">
          {label}
          {required && <sup className="text-red text-16">*</sup>}
        </label>

        <input
          className={classnames(
            'w-full appearance-none focus:outline-none bg-transparent h-full p-12 border border-input-border',
            inputClassName,
          )}
          type={type}
          id={name}
          autoComplete="new-password"
          name={name}
          multiple={multiple}
          placeholder="Please enter value here"
          value={value}
          maxLength={maxLength}
          onChange={(e) => onChange(e)}
          font-customisation="para-text"
        />

        {charges ? (
          <div className="absolute top-0 right-0 bg-white flex items-center px-16 mt-46 mr-8">
            <div className="text-14">{charges}</div>
          </div>
        ) : null}
      </div>
      <div className="px-2 text-input-hint opacity-70 text-12 mt-4">
        {error ? <span className="text-input-error opacity-100">{error}</span> : null}
        {hint && !error ? <span>{hint}</span> : null}
      </div>
    </div>
  );
};

export default FormInput;
